import React from 'react'
import { T } from '@transifex/react'
import { useAppSelector } from '../../../state/hooks'
import { selectToPay } from '../../../state/slices/currentSale/currentSaleSlice'
import {
  getOutstandingBalanceAfterChange,
  isAccountBalancePaymentAdded,
} from '../../../functions/sale'
import { useFormatCurrencyValue } from './useFormatCurrencyValue'

export const ToPaySection = () => {
  const { payments, payAccountBalance, finals, change } = useAppSelector(
    selectToPay
  )
  const formatCurrencyValue = useFormatCurrencyValue()
  const shouldShowToPay =
    payments.length || isAccountBalancePaymentAdded(payAccountBalance)

  if (!shouldShowToPay) {
    return null
  }
  const toPayAmount = getOutstandingBalanceAfterChange({
    finals,
    payments,
    payAccountBalance,
    change,
  })
  return (
    <section className="sale-summary-section sale-summary-section--indent sale-summary-section--balance sale-summary-section-divider-top sale-summary-section-divider-btm">
      <ul className="sale-summary-list">
        <li className="sale-summary-line">
          <div className="sale-summary-line-item sale-summary-line-item--label vd-text-signpost">
            <T
              _str="To Pay"
              _context="Label for to pay on sale summary panel"
            />
          </div>
          <div className="sale-summary-line-item sale-summary-line-item--value vd-text-intro">
            {formatCurrencyValue(toPayAmount)}
          </div>
        </li>
      </ul>
    </section>
  )
}
